import { Action } from '@ngrx/store';
import { ParameterType } from '../../../_generated';

export enum ParameterIdAction {
  Set = '[ParameterId] Set',
  Reset = '[ParameterId] Reset',
  Sync = '[ParameterId] Sync',
  Add = '[ParameterId] Add',
  Remove = '[ParameterId] Remove',
}

export interface ParameterIdSetPayload {
  parameterType: ParameterType;
  parameterIds: number[];
}

export interface ParameterIdAddRemovePayload {
  parameterType: ParameterType;
  parameterId: number;
}

export class Set implements Action {
  readonly type = ParameterIdAction.Set;

  constructor(public payload: ParameterIdSetPayload) {}
}

export class Reset implements Action {
  readonly type = ParameterIdAction.Reset;
}

export class Sync implements Action {
  readonly type = ParameterIdAction.Sync;

  constructor(public payload: ParameterIdSetPayload) {}
}

export class Add implements Action {
  readonly type = ParameterIdAction.Add;

  constructor(public payload: ParameterIdAddRemovePayload) {}
}

export class Remove implements Action {
  readonly type = ParameterIdAction.Remove;

  constructor(public payload: ParameterIdAddRemovePayload) {}
}

export type ParameterIdActionType = Set | Reset | Sync | Add | Remove;
